import React from 'react'
import {GET_FILE_URL} from '../../../onboarding/core/_requests'

export const DisplayBgImage = ({
  imgName,
  height,
  alt,
  width,
  fit,
  className,
}: {
  imgName: string | undefined
  height?: string | number
  alt: string | undefined
  width?: string | undefined | number
  className?: string
  fit?: 'fill' | 'cover' | 'contain'
}) => {
  const containerStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    overflow: 'hidden',
  }

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: fit || 'cover',
  }

  return (
    <>
      <div style={containerStyle}>
        {imgName && (
          <img
            src={`${GET_FILE_URL}/${encodeURIComponent(imgName || '')}`}
            height='240px'
            width={width}
            alt={alt}
            style={imageStyle}
            className={className}
          />
        )}
      </div>
    </>
  )
}
